module.exports = __webpack_public_path__ + "img/GALLERY-ERTIGA-BOOSTER-GREEN-4.b6c4e890.jpg";